var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detail)?_c('span',[(_vm.detail.type)?_c('el-tag',{attrs:{"type":_vm.detail.type || ''}},[_vm._v(_vm._s(_vm.detail.title || '-'))]):_c('span',[_vm._v(_vm._s(_vm.detail.title || '-'))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }